import { StandardEvents } from '@shopify/events';

const floatingCart = document.querySelector('[data-wl-floating-cart]');

if (floatingCart) {
  const countBadge = floatingCart.querySelector('[data-wl-cart-count]');
  let version = 0;

  function updateCount(value) {
    const count = Number(value);
    if (!Number.isFinite(count) || count < 0 || !countBadge) return;
    const quantity = Math.floor(count);
    version += 1;
    countBadge.textContent = quantity > 99 ? '99+' : String(quantity);
    countBadge.hidden = quantity === 0;
    floatingCart.setAttribute('aria-label', quantity === 0
      ? 'Open shopping cart'
      : 'Open shopping cart, ' + quantity + (quantity === 1 ? ' item' : ' items'));
  }

  async function refreshCount() {
    const requestedVersion = version;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestedVersion === version) updateCount(cart.item_count);
    } catch (_) {
    }
  }

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!event.promise) {
      refreshCount();
      return;
    }
    Promise.resolve(event.promise)
      .then(({ cart, detail }) => {
        const count = cart?.totalQuantity ?? detail?.itemCount;
        if (count === undefined || count === null) refreshCount();
        else updateCount(count);
      })
      .catch(() => refreshCount());
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCount();
  });

  floatingCart.addEventListener('click', () => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) {
      window.location.assign(floatingCart.dataset.cartUrl || '/cart');
      return;
    }
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    customElements.whenDefined('theme-drawer').then(() => {
      if (typeof drawer.open === 'function') drawer.open();
      else window.location.assign(floatingCart.dataset.cartUrl || '/cart');
    });
  });

  refreshCount();
}
